import { render, staticRenderFns } from "./ModalValorDiferenciadoDesabilitando.vue?vue&type=template&id=0afdd986&scoped=true&"
import script from "./ModalValorDiferenciadoDesabilitando.vue?vue&type=script&lang=js&"
export * from "./ModalValorDiferenciadoDesabilitando.vue?vue&type=script&lang=js&"
import style0 from "./ModalValorDiferenciadoDesabilitando.vue?vue&type=style&index=0&id=0afdd986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afdd986",
  null
  
)

export default component.exports